import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Experienced developers can't solve this problem",
  "description": "",
  "published": "2012-11-02T00:00:00.000Z",
  "redirect_from": ["/blog/experienced-developers-cant-solve-this-problem/swizec/5496"],
  "categories": "Bitwise operation, Integers, JavaScript, jQuery, Languages, Programming, Uncategorized",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <blockquote>
      <p parentName="blockquote">{`In 8 or less characters of `}<a parentName="p" {...{
          "href": "http://en.wikipedia.org/wiki/JavaScript",
          "title": "JavaScript"
        }}>{`JavaScript`}</a>{` write an expression that evaluates to `}<strong parentName="p">{`-265`}</strong>{`. You are not allowed to use "-265" as the solution or use the `}{`*`}{` character.`}</p>
    </blockquote>
    <p>{`The other day someone asked this on `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Internet_Relay_Chat",
        "title": "Internet Relay Chat"
      }}>{`IRC`}</a>{`.`}</p>
    <p>{`Everyone pounced on the problem and after a lot of discussion about how strange the 265 number is and whether he didn't mean 256 we decided it was impossible to solve in just eight characters.`}</p>
    <p>{`The shortest solution I could come up with was this:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`~(1 << 8) - 8;
`}</code></pre>
    <p>{`Shifting left for eight places gives you 257, negating gives -257, then you just subtract 8 and voila, you have -265.`}</p>
    <p>{`Except it's `}<strong parentName="p">{`9 characters`}</strong>{` long ... not a solution.`}</p>
    <p>{`But I did learn about `}<a parentName="p" {...{
        "href": "https://developer.mozilla.org/en-US/docs/JavaScript/Reference/Operators/Bitwise_Operators"
      }}>{`javascript bitwise operations`}</a>{`, so this exercise in futility was not a total waste. Not sure what I'm going to use them for, but it can't hurt :)`}</p>
    <p>{`So, come up with the answer yet?`}</p>
    <p><img parentName="p" {...{
        "src": "https://cache.ohinternet.com/images/thumb/2/2d/Trollface_HD.png/618px-Trollface_HD.png",
        "alt": "Trollface",
        "title": "Trollface"
      }}></img></p>
    <p>{`Here's some solutions:`}</p>
    <ul>
      <li parentName="ul"><em parentName="li">{`-1060/4`}</em>{` is just 7 characters`}</li>
      <li parentName="ul"><em parentName="li">{`-256-9`}</em>{` is just 6 characters`}</li>
      <li parentName="ul">{`_`}{`-530/2 `}{`_`}{`is only 6 characters as well`}</li>
      <li parentName="ul"><em parentName="li">{`~264`}</em>{` is just 4 characters (by `}<a parentName="li" {...{
          "href": "http://twitter.com/zidarsk8"
        }}>{`@zidarsk8`}</a>{`)`}</li>
    </ul>
    <p>{`And so on, you get the picture. Shameful as it is, I couldn't come up with an answer `}<em parentName="p">{`at all`}</em>{`. Never even occurred to me. I think this happens to a lot of developers who have been in the game for too long, we immediately try creating elegant solutions where simple ones will do.`}</p>
    <p>{`If you solved this on your own, congratulations. You are better than me.`}</p>
    <h6 {...{
      "id": "related-articles"
    }}>{`Related articles`}</h6>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://tuts.pinehead.tv/2012/09/13/ten-things-i-wish-i-knew-earlier-about-the-linux-command-line-2/"
        }}><img parentName="a" {...{
            "src": "https://i.zemanta.com/noimg_98_80_80.jpg",
            "alt": null
          }}></img></a><a parentName="li" {...{
          "href": "http://tuts.pinehead.tv/2012/09/13/ten-things-i-wish-i-knew-earlier-about-the-linux-command-line-2/"
        }}>{`Ten things I wish I knew earlier about the Linux command line`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.yesodweb.com/blog/2012/10/yesod-fay-js"
        }}><img parentName="a" {...{
            "src": "https://i.zemanta.com/noimg_20_80_80.jpg",
            "alt": null
          }}></img></a><a parentName="li" {...{
          "href": "http://www.yesodweb.com/blog/2012/10/yesod-fay-js"
        }}>{`Yesod, AngularJS and Fay`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://cs.stackexchange.com/questions/3484/converting-function-to-bitwise-only"
        }}><img parentName="a" {...{
            "src": "https://i.zemanta.com/noimg_81_80_80.jpg",
            "alt": null
          }}></img></a><a parentName="li" {...{
          "href": "http://cs.stackexchange.com/questions/3484/converting-function-to-bitwise-only"
        }}>{`Converting function to bitwise only?`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.nczonline.net/blog/2012/08/01/a-critical-review-of-ecmascript-6-quasi-literals/"
        }}><img parentName="a" {...{
            "src": "https://i.zemanta.com/noimg_102_80_80.jpg",
            "alt": null
          }}></img></a><a parentName="li" {...{
          "href": "http://www.nczonline.net/blog/2012/08/01/a-critical-review-of-ecmascript-6-quasi-literals/"
        }}>{`A critical review of ECMAScript 6 template strings`}</a></li>
    </ul>
    <p><a parentName="p" {...{
        "href": "http://www.zemanta.com/?px",
        "title": "Enhanced by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/zemified_e.png?x-id=c50c54c5-8990-4d50-8b07-b47dc0450779",
          "alt": "Enhanced by Zemanta"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      